export default {"src":"/_next/static/media/couches.e6b331da.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};